'use strict';

var ajax = require('./ajax'),
	minicart = require('./minicart'),
	dialog = require('./dialog'),
	formPrepare = require('./pages/checkout/formPrepare'),
	validator = require('./validator'),
	util = require('./util'),
	linchpin = require('int_googletagmanager/linchpin/giftsubscription');

var setAddToCartHandler = function (e) {
	e.preventDefault();
	var form = $(this).closest('form');

	var options = {
		url: util.ajaxUrl(form.attr('action')),
		method: 'POST',
		cache: false,
		data: form.serialize()
	};
	$.ajax(options).done(function (response) {
		form.find('span.error').hide();
		if (response.success) {
			ajax.load({
				url: Urls.minicartGC,
				data: {lineItemId: response.result.lineItemId},
				callback: function (response) {
					// GTM Linchpin analytics
					if (SitePreferences.GTM_ENABLED) {
						linchpin.giftSubscriptionAddedToBasketEvent(e);
					}
					minicart.show(response);
					form.find('input[type!="hidden"],textarea').val('');
				}
			});
		} else {
			for (var id in response.errors.FormErrors) {
				var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
				if (!$errorEl || $errorEl.length === 0) {
					$errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
					$('#' + id).after($errorEl);
				}
				$errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
				$('.addToBasketButton').prop('disabled', true);
			}
		}
	}).fail(function (xhr, textStatus) {
		// failed
		if (textStatus === 'parsererror') {
			window.alert(Resources.BAD_RESPONSE);
		} else {
			window.alert(Resources.SERVER_CONNECTION_ERROR);
		}
	});
};
/**
 * @function
 * @description initialize opening a dialog with form to modify email address
 * 				for electronic gift cards (GiftCertificateLineItem)
 */
function initEditAddressPopup() {
	$('.edit-giftcert-address').on('click', function (e) {
		e.preventDefault();
		var url = util.appendParamsToUrl($(this).attr('href'));
		dialog.open({
			url: url,
			options:{
				title: Resources.GIFTCERT_EDIT_ADDRESS_TITLE,
				dialogClass: 'edit-gifcert-dialog',
				open: function () {
					// init cancel event
					$('.cancel-giftcert-address').on('click', function (e) {
						e.preventDefault();
						dialog.close();
					});
					// init form validation
					validator.init();
					var $addressForm = $('#GiftCertificateForm');
					// init save event
					$('.save-giftcert-address').on('click', function (e) {
						e.preventDefault();
						if (!$addressForm.valid()) {
							return;
						}
						dialog.close();
						ajax.load({
							url: $('#GiftCertificateForm').attr('action'),
							data: $('#GiftCertificateForm').serialize(),
							target: $('.address-gc-' + $('input[name$="giftCertificateID"]').val())
						});
						// reinit shipping address form for validation
						if ($('.shipment-container .shippingaddress .select-address').length > 0) {
							formPrepare.init({
								continueSelector: '[name$="addressSelection_save"]',
								formSelector: '[id$="multishipping_addressSelection"]'
							});
						}
					});
					// Disable button if form is invalid
					formPrepare.init({
						formSelector: '#GiftCertificateForm',
						continueSelector: '.save-gifcert-address'
					});
				}
			}
		});
	});
}


var emailMatchValidationAdd = function () {
	$.validator.addMethod('confirm-email-egift', function (v) {
		var $form = $('#AddGiftCertificateForm'),
			$email = $form.find('[name$=_purchase_recipientEmail]');

		if ($email.val() === v) {
			return true;
		} else if ($email.val() !== '') {
			return false;
		}

	}, Resources.CONFIRM_EMAIL_ERROR);
};
/**
 * @return {boolean} false if the emails match
 */
var emailConfirmCheck = function () {
	var $form = $('#AddGiftCertificateForm'),
		email = $form.find('[name$=_purchase_recipientEmail]').val(),
		confirmEmail = $form.find('[name$=confirmRecipientEmail]').val();
	return email !== confirmEmail;
};
exports.init = function () {

	$('.addToBasketButton').on('click', setAddToCartHandler);

	if ($('#AddGiftCertificateForm').length > 0) {
		formPrepare.init({
			formSelector: '#AddGiftCertificateForm',
			continueSelector: '.addToBasketButton',
			customCallback: emailConfirmCheck,
			keyup: false
		});
		emailMatchValidationAdd();
	} else if ($('.pdpForm').length > 0) {
		formPrepare.init({
			formSelector: '.pdpForm',
			continueSelector: '.add-to-cart'
		});
	}
};
exports.initEditAddressPopup = initEditAddressPopup;
